import React, {
  useEffect,
  useState,
} from "react";

import { useNavigate } from "react-router-dom";

import PageLayout from "../../layout/PageLayout";
import TableLayout from "../../components/table/TableLayout";

import {
  getCoupons,
} from "./CouponService";

import {
  couponColumns,
} from "./CouponColumns";

import "./Coupons.css";

function Coupons() {

  const navigate = useNavigate();

  const [coupons, setCoupons] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [search, setSearch] =
    useState("");

  const [statusFilter, setStatusFilter] =
    useState("all");

  const [rewardFilter, setRewardFilter] =
    useState("all");

  useEffect(() => {

    loadCoupons();

  }, []);

  async function loadCoupons() {

    try {

      setLoading(true);

      const data =
        await getCoupons();

      setCoupons(data);

    } finally {

      setLoading(false);

    }

  }

  /* ==========================================
      FILTER
  ========================================== */

  const filteredCoupons =
    coupons.filter((coupon) => {

      const keyword =
        search.toLowerCase();

      const matchesSearch =

        coupon.code
          ?.toLowerCase()
          .includes(keyword)

        ||

        coupon.title
          ?.toLowerCase()
          .includes(keyword);

      let matchesStatus = true;

      if (statusFilter === "active") {

        matchesStatus =
          coupon.active === true;

      }

      if (statusFilter === "inactive") {

        matchesStatus =
          coupon.active === false;

      }

      let matchesReward = true;

      if (rewardFilter !== "all") {

        matchesReward =
          coupon.rewardType === rewardFilter;

      }

      return (
        matchesSearch &&
        matchesStatus &&
        matchesReward
      );

    });

  /* ==========================================
      SORT
  ========================================== */

  const sortedCoupons =
    [...filteredCoupons].sort(
      (a, b) => {

        const aTime =
          a.createdAt?.toMillis?.() || 0;

        const bTime =
          b.createdAt?.toMillis?.() || 0;

        return bTime - aTime;

      }
    );

  const columns =
    couponColumns({

      onView: (coupon) => {

        navigate(
          `/admin/coupons/${coupon.documentId}`
        );

      },

    });

  return (

    <PageLayout
      title="Coupons"
      subtitle="Manage coupon codes and rewards."
    >

      <div
        style={{
          display: "flex",
          gap: 12,
          marginBottom: 20,
          flexWrap: "wrap",
        }}
      >

        <select
          value={statusFilter}
          onChange={(e) =>
            setStatusFilter(
              e.target.value
            )
          }
        >
          <option value="all">
            All Status
          </option>

          <option value="active">
            Active
          </option>

          <option value="inactive">
            Inactive
          </option>

        </select>

        <select
          value={rewardFilter}
          onChange={(e) =>
            setRewardFilter(
              e.target.value
            )
          }
        >

          <option value="all">
            All Rewards
          </option>

          <option value="contacts">
            Contacts
          </option>

          <option value="premium">
            Premium
          </option>

        </select>

      </div>

      <TableLayout

        title="Coupons"

        total={sortedCoupons.length}

        columns={columns}

        data={sortedCoupons}

        loading={loading}

        search={search}

        onSearch={setSearch}

        onRefresh={loadCoupons}

        addLabel="Add Coupon"

        onAdd={() =>
          navigate(
            "/admin/coupons/add"
          )
        }

        emptyMessage="No coupons found."

      />

    </PageLayout>

  );

}

export default Coupons;